const { gsap } = require('gsap');

const AnimeIntro = (()=>{

    const introWebdoor = (()=>{
        const webdoorIntro = document.querySelector('#webdoor-start');

        if(webdoorIntro)
            webdoorIntro.classList.add('motion-in');

    });

   

    return {
        init: ()=>{
            //introWebdoor();
        }
    }

})();

module.exports = AnimeIntro;